import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import CampaignControl from "./CampaignControl"; // eslint-disable-next-line require-await

export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren, _ref) {
    var campaignTracking, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            campaignTracking = _ref.campaignTracking;
            props = {
              isRehydrating: true,
              defaultValue: domNode.getAttribute("data-default-value"),
              name: domNode.getAttribute("name"),
              parameterToTrack: domNode.getAttribute("data-parameter-to-track"),
              service: campaignTracking
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(CampaignControl, props));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
})();